module.exports = __webpack_public_path__ + "static/media/learn3.3ee5bdc7.png";